import { atom } from 'recoil'

export const modalDeleteCampaignState = atom({
  key: 'CampaignListModalDeleteCampaignState',
  default: {
    show: false,
    idCampaign: 0,
    idMessage: 0
  }
})
